import { motion, useReducedMotion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../i18n';
import { ActionLink } from './Common';

export const Hero = () => {
  const { t, lang } = useLanguage();
  const reduced = useReducedMotion();
  return <section id="home" className="hero" data-testid="hero-section">
    <div className="hero-tech-plate" aria-hidden="true">
      <span className="hero-circuit-trace hero-circuit-trace-a" />
      <span className="hero-circuit-trace hero-circuit-trace-b" />
      <span className="hero-circuit-trace hero-circuit-trace-c" />
      <span className="hero-circuit-trace hero-circuit-trace-d" />
      <i className="hero-circuit-node hero-circuit-node-a" />
      <i className="hero-circuit-node hero-circuit-node-b" />
      <i className="hero-circuit-node hero-circuit-node-c" />
      <b className="hero-circuit-sweep" />
    </div>
    <div className="hero-grid page-width">
      <div className="hero-copy">
        {t.eyebrow && <motion.p className="hero-eyebrow" initial={reduced ? false : { opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .55 }}>{t.eyebrow}</motion.p>}
        <h1 key={lang} data-testid="hero-title">{t.hero.map((line, i) => <span key={line} className={`hero-line hero-line-${i + 1}${i === 1 ? ' hero-line-accent' : ''}`}><motion.span initial={reduced ? false : { y: '110%' }} animate={{ y: 0 }} transition={{ duration: .8, delay: .12 + i * .12 }}>{line}</motion.span></span>)}</h1>
        {t.intro && <motion.p className="hero-description" data-testid="hero-description" initial={reduced ? false : { opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: .42, duration: .65 }}>{t.intro}</motion.p>}
        <motion.div className="hero-actions" initial={reduced ? false : { opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: .55, duration: .65 }}>
          <ActionLink href="#motors" testId="hero-explore">{t.explore}</ActionLink>
          <a className="hero-text-link" href="#technology">{t.discover}<ArrowUpRight size={16}/></a>
        </motion.div>
      </div>
    </div>
    <div className="hero-bottom"><div className="page-width hero-metrics">{[[t.metric1 || t.thrust, lang === 'de' ? 'BIS ZU 22 KG' : lang === 'en' ? 'UP TO 22 KG' : '22 KG'], [t.metric2 || t.power, lang === 'de' ? 'BIS ZU 5000 W' : lang === 'en' ? 'UP TO 5000 W' : '5000 W'], [t.metric3 || t.cells, '2–14S'], [t.metric4 || t.protection, 'IPX6']].map(([label, value], i) => <div className="hero-metric" key={label}><span>0{i + 1} |</span><strong>{value}</strong><small>{label}</small></div>)}</div></div>
  </section>;
};
